import axios from "axios";

export const getCompetition = async (id, token) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/getCompetition/${id}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};
